import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_2 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/CustomFormList/index.vue';
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/SmyFullPopup.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ExtFieldPc.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "detail-control-table"
  }, [_vm.config.isEdit ? _c('div', {
    staticClass: "detail-control-add-icon",
    on: {
      "click": function ($event) {
        ;
        _vm.isEdit = false, _vm.isShowComponentModal = !_vm.isShowComponentModal;
      }
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": "/spa_static_mobile/icon/order-but120_120@3x.png"
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "table",
    style: "max-height: " + _vm.maxHeight + "px"
  }, _vm._l(_vm.tableList, function (item, i) {
    return _c('div', {
      key: i,
      staticClass: "card card-item",
      on: {
        "click": function ($event) {
          return _vm.edit(item);
        }
      }
    }, [_vm.config.isEdit ? _c('svg', {
      staticClass: "vux-x-icon vux-x-icon-ios-close-outline close-btn",
      attrs: {
        "size": "24",
        "type": "ios-close-outline",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 512 512"
      },
      on: {
        "click": function ($event) {
          return _vm.deleteDetailCtrlTableList(item.nodeId);
        }
      }
    }, [_c('path', {
      staticClass: "st0",
      attrs: {
        "d": "M403.1 108.9c-81.2-81.2-212.9-81.2-294.2 0s-81.2 212.9 0 294.2c81.2 81.2 212.9 81.2 294.2 0s81.2-213 0-294.2zm-12.3 281.9c-74.3 74.3-195.3 74.3-269.6 0-74.3-74.3-74.3-195.3 0-269.6s195.3-74.3 269.6 0c74.4 74.3 74.4 195.3 0 269.6z"
      }
    }), _c('path', {
      staticClass: "st0",
      attrs: {
        "d": "M340.2 160l-84.4 84.2-84-83.8-11.8 11.8 84 83.8-84 83.8 11.8 11.8 84-83.8 84.4 84.2 11.8-11.8-84.4-84.2 84.4-84.2z"
      }
    })]) : _vm._e(), _c(__unplugin_components_0, {
      attrs: {
        "extFields": item.customField
      }
    }), _vm._l(_vm.sysColumns, function (field, j) {
      return _c('div', {
        key: j,
        staticClass: "operate-msg font-size-h3-normal"
      }, [_vm._v(" " + _vm._s(field.title) + "： " + _vm._s(item[field.key]) + " ")]);
    })], 2);
  }), 0), _vm.config.isEdit ? _c(__unplugin_components_1, {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }],
    staticClass: "detail-control-popup",
    attrs: {
      "width": "100%",
      "position": "right",
      "popup-style": {
        background: '#f8f8f8'
      }
    },
    model: {
      value: _vm.isShowComponentModal,
      callback: function ($$v) {
        _vm.isShowComponentModal = $$v;
      },
      expression: "isShowComponentModal"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_c(__unplugin_components_2, {
    ref: "customFormList",
    attrs: {
      "data": _vm.fieldList
    },
    on: {
      "on-change": function ($event) {
        _vm.fieldData = $event;
      }
    }
  }), _c('div', {
    staticClass: "bottom-bar",
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  }, [_c('div', {
    staticClass: "btn-body"
  }, [_c('x-button', {
    staticClass: "no-border-radius",
    staticStyle: {
      "color": "#3ccba6"
    },
    attrs: {
      "type": "default",
      "show-loading": _vm.loading
    },
    nativeOn: {
      "click": function ($event) {
        _vm.isShowComponentModal = false;
      }
    }
  }, [_vm._v(" " + i18n.tc("11") + " ")])], 1), _c('div', {
    staticClass: "btn-body"
  }, [_c('x-button', {
    staticClass: "no-border-radius",
    attrs: {
      "type": "primary",
      "show-loading": _vm.loading,
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + i18n.tc("12") + " ")])], 1)])], 1)], 1)]) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };